import type { CmsProps } from '../../types/cms'
import styled from '@emotion/styled'
import { Background } from '../surfaces/background'

export const PictureInfoPanelContainer = styled(Background)<CmsProps>`
  color: ${({ textColour }) => textColour ?? '#000'};

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  li {
    color: inherit;
  }

  h1,
  h2,
  h3,
  h4 {
    text-align: center;
    margin-bottom: 2rem;
  }

  p {
    margin: 0;
  }
`

export const FeaturesList = styled.ul<CmsProps>`
  list-style: none;
  margin: 0;
  padding: 0;
  color: inherit;

  li {
    list-style: none;
    margin-bottom: 1.2rem;
    color: inherit;
  }

  p {
    margin: ${({ theme }) => theme.spacing(0, 0, 0, 4)};
    color: inherit;
  }
`
